import * as React from 'react';
import {
  ArrayInput,
  Edit,
  EditProps,
  FormDataConsumer,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  useTranslate,
} from 'react-admin';

export const UserEdit = ({ basePath, resource, id }: EditProps) => {
  const translate = useTranslate();
  return (
    <Edit basePath={basePath} resource={resource} id={id}>
      <SimpleForm>
        <TextInput source="email" disabled />
        <ReferenceInput source="role" reference="roles">
          <SelectInput
            optionText={(record: any) => translate(record.id)}
            validate={required()}
          />
        </ReferenceInput>
        <FormDataConsumer>
          {({ formData }) =>
            ['role.dealeruser', 'role.dealeradmin'].includes(
              formData?.role,
            ) && (
              <ArrayInput source="departments" validate={required()}>
                <SimpleFormIterator>
                  <ReferenceInput
                    label={translate('resources.departments.department')}
                    source="id"
                    reference="departments"
                  >
                    <SelectInput
                      optionText="name"
                      optionValue="id"
                      validate={required()}
                    />
                  </ReferenceInput>
                </SimpleFormIterator>
              </ArrayInput>
            )
          }
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};
